import { gql } from '@apollo/client';
import checkPointFieldsFragment from './checkPointFieldsFragment';

const GET_CHECK_POINT_BY_ID = gql`
  query GetCheckPointById($checkPointId: Int!) {
    checkPointEditRemovalPermission(checkPointId: $checkPointId) {
      canUserEditOrRemoveSubmittedCheckPoint
      isSubmittedCheckPointEditableOrRemovable
    }
    checkPoint(checkPointId: $checkPointId) {
      ...CheckPointFields
    }
  }
  ${checkPointFieldsFragment}
`;

export default GET_CHECK_POINT_BY_ID;
